export default __webpack_public_path__ + "static/media/45.e4d1b248.jpg";